export const labelFontFamily = 'Helvetica, Arial, Courier';
export const animationDuration = 3000;
export const animationEasing = 'easeOutQuart';
export const xLabelFormat = {
  autoSkip: false,
  fontColor: '#424242',
  fontFamily: labelFontFamily,
  fontSize: 14,
  lineHeight: 1.5,
  maxRotation: 0
};

export const determineXLabels = function () {
  const xLabels = [];
  const xLabelMin = 1976;
  const xLabelMax = 2021;
  let ignoreTickUntilEnd = false;
  let xLabelTick = 5;
  if (window.innerWidth < 1024) {
    xLabelTick = 9;
  }
  for (let i = xLabelMin; i <= xLabelMax; i++) {
    if ((i - xLabelMin) % xLabelTick === 0) {
      if (
        (xLabelMax - i) <= (xLabelTick / 2) &&
        i !== xLabelMax
      ) {
        ignoreTickUntilEnd = true;
        xLabels.push('');
        continue;
      }
      xLabels.push(i.toString(10));
      continue;
    }
    if (!ignoreTickUntilEnd || i + 1 <= xLabelMax) {
      xLabels.push('');
    } else {
      xLabels.push(i);
    }
  }
  return xLabels;
};
